import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=ae39ac5c&"
import script from "./UserChip.vue?vue&type=script&lang=ts&"
export * from "./UserChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports